/**
 *
 *  목적: 로그인한 사용자의 정보를 당겨와 채널톡을 통해 상담시 사용자가 개인정보를 직접 입력하지 않는 편의성을 제공
 *
 *  채널IO SDK 공식문서]
 * @see  https://developers.channel.io/docs/web-channel-io
 *
 */

/**
 * 타입 정의]
 * 이름 또는 이메일 중 하나만 업데이트하는 경우도 있어서 파라미터를 옵셔널로 처리
 * 세션에서 이름 또는 이메일이 존재하지 않는 경우도 있어서 null도 타입에 넣음
 *
 * 차이점]
 * 이름이 없는 경우는 채널톡에서 프로필상 사용자의 이름 대신 이메일로 표기됨
 * 이름은 있고 이메일이 없는 경우는 채널 톡 내에서 이름은 자동입력되있고 이메일을 입력받는 템플릿이 뜸
 *
 */

export const updateChannelTalkUser = (
  profile?: {
    name?: string | null;
    email?: string | null;
    mobileNumber?: string | null;
  } | null
) => {
  if (!process.env.NEXT_PUBLIC_CHANNEL_IO_APP_KEY) {
    return;
  }

  window.ChannelIO?.(
    "updateUser",
    {
      // TODO: 국가에 따라 변경
      language: "ko",
      profile,
    },
    function onUpdateUser(error) {
      if (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
  );
};

/**
 * 이슈]
 * 채널톡이 작동중인 상태에서 사용자의 프로필을 변경했을 때, 상담이 진행중인 상태에서는 채널톡에 개인정보 변경이 즉각적으로 안되고
 * 새로고침을 해야 변경된 내용이 반영되는 문제가 있음
 */
